/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountCodeExtended
 */
export interface AccountCodeExtended {
    /**
     * 
     * @type {string}
     * @memberof AccountCodeExtended
     */
    accountCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCodeExtended
     */
    carrier?: string | null;
}

export function AccountCodeExtendedFromJSON(json: any): AccountCodeExtended {
    return AccountCodeExtendedFromJSONTyped(json, false);
}

export function AccountCodeExtendedFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCodeExtended {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountCode': !exists(json, 'accountCode') ? undefined : json['accountCode'],
        'carrier': !exists(json, 'carrier') ? undefined : json['carrier'],
    };
}

export function AccountCodeExtendedToJSON(value?: AccountCodeExtended | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountCode': value.accountCode,
        'carrier': value.carrier,
    };
}


